import { apiFetch } from './api';

export interface QuotaStatus {
  used: number;
  limit: number;
  bonus: number;
  remaining: number;
  exceeded: boolean;
}

export interface UsageSnapshot {
  period: string;
  ai_generates: QuotaStatus;
  ai_modifies: QuotaStatus;
  sends: QuotaStatus;
}

export async function getUsage(): Promise<UsageSnapshot> {
  return apiFetch<UsageSnapshot>('/api/usage');
}
